import React from 'react';

/**
 * The animated "loading" mark for the report pages: two counter-turning arcs
 * around a pulsing KinetiQ trace. Pure CSS, so it shows before anything else
 * of the report has loaded, and it holds still for reduced motion.
 */
export function ReportLoader({ label = 'Loading', dark = false }) {
  return (
    <div className={`kq-loader${dark ? ' is-dark' : ''}`} role="status" aria-live="polite">
      <style>{LOADER_CSS}</style>
      <div className="kq-loader-mark" aria-hidden="true">
        <span className="kq-loader-ring a" />
        <span className="kq-loader-ring b" />
        <span className="kq-loader-core">
          <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
          </svg>
        </span>
      </div>
      <p className="kq-loader-label">{label}<span className="kq-loader-dots"><i>.</i><i>.</i><i>.</i></span></p>
    </div>
  );
}

const LOADER_CSS = `
.kq-loader { display:flex; flex-direction:column; align-items:center; gap:14px; color:#0b2434; font:600 13px Arial,Helvetica,sans-serif; }
.kq-loader.is-dark { color:#e6fbf9; }
.kq-loader-mark { position:relative; width:84px; height:84px; }
.kq-loader-ring { position:absolute; inset:0; border-radius:50%; border:3px solid transparent; }
.kq-loader-ring.a { border-top-color:#19c7c3; border-right-color:#19c7c3; animation:kq-turn 1.1s linear infinite; }
.kq-loader-ring.b { inset:10px; border-bottom-color:#0e7490; border-left-color:#0e7490; animation:kq-turn 1.6s linear infinite reverse; }
.kq-loader-core { position:absolute; inset:22px; border-radius:50%; display:flex; align-items:center; justify-content:center; color:#087f7f; background:rgba(25,199,195,.12); animation:kq-beat 1.4s ease-in-out infinite; }
.kq-loader.is-dark .kq-loader-core { color:#5eead4; background:rgba(25,199,195,.18); }
.kq-loader-label { margin:0; letter-spacing:.02em; }
.kq-loader-dots i { font-style:normal; animation:kq-dot 1.2s infinite; }
.kq-loader-dots i:nth-child(2) { animation-delay:.2s; }
.kq-loader-dots i:nth-child(3) { animation-delay:.4s; }
@keyframes kq-turn { to { transform:rotate(360deg); } }
@keyframes kq-beat { 0%,100% { transform:scale(.92); box-shadow:0 0 0 0 rgba(25,199,195,.35); } 50% { transform:scale(1); box-shadow:0 0 0 10px rgba(25,199,195,0); } }
@keyframes kq-dot { 0%,20% { opacity:0; } 50% { opacity:1; } 100% { opacity:0; } }
@media (prefers-reduced-motion: reduce) {
  .kq-loader-ring, .kq-loader-core, .kq-loader-dots i { animation:none; }
}
`;
